import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { DialogProps } from '@material-ui/core/Dialog';
import { inject } from 'mobx-react';
import * as React from 'react';
import { IAssessment } from 'src/Definitions';
import { IStores } from 'src/Stores';

interface ICompleteAssessmentDialogProps extends DialogProps {
    close?: () => void;
    markAssessmentCompletion?: (assessment: IAssessment, completeAssessment: boolean, overrideUncompletedActionItems?: boolean) => void;
    selectedAssessment?: IAssessment;
}

class CompleteAssessmentDialog extends React.Component<ICompleteAssessmentDialogProps> {
    public render() {
        return (
            <Dialog open={this.props.open}>
                <DialogTitle>
                    {this.props.selectedAssessment && <>Mark as Complete - {this.props.selectedAssessment!.name}</>}
                </DialogTitle>
                <DialogContent>This assessment still has action items that have not yet been completed. Proceed anyways?</DialogContent>
                <DialogActions>
                    <Button onClick={this.props.close} data-cy="close">No</Button>
                    <Button
                        onClick={this.confirm}
                        data-cy="close"
                        color="primary"
                        variant="contained"
                    >Yes</Button>
                </DialogActions>
            </Dialog>
        );
    }

    private confirm = () => {
        this.props.markAssessmentCompletion!(this.props.selectedAssessment!, true, true);
        this.props.close!();
    }
}

const InjectedCompleteAssessmentDialog = inject<IStores, ICompleteAssessmentDialogProps, Partial<ICompleteAssessmentDialogProps>, any>(
    (stores: IStores) => ({
        close: stores.assessments.closeConfirmDialog,
        markAssessmentCompletion: stores.assessments.markAssessmentCompletion,
        selectedAssessment: stores.assessments.selectedAssessment
    })
)(CompleteAssessmentDialog);

export default InjectedCompleteAssessmentDialog;


// WEBPACK FOOTER //
// ./src/assessments/CompleteAssessmentDialog.tsx